import { InputCurrency } from "@sellar-io/components";
import type {
  PriceTierListResponseType,
  ProductPriceTierBatchCreateRequestType,
} from "@sellar-io/api-v2/types";
import { twMerge } from "tailwind-merge";
import { InputContainer } from "@sellar-io/components";
import {
  TableLegacyTR,
  TableLegacyTD,
} from "../../../../../components/table/TableLegacy";
import {
  formatPriceInputToApi,
  usePriceFormat,
} from "../../../../../hooks/usePriceFormat";

const handleUpdateItems = (
  priceTierItems: ProductPriceTierBatchCreateRequestType | undefined,
  ProductId: number,
  PriceTierId: number,
  price: number | null,
) => {
  if (price !== null && price < 0) return priceTierItems;

  const filteredPriceTierItems = (priceTierItems ?? []).filter(
    (item) => item.PriceTierId !== PriceTierId,
  );

  if (price !== null && price >= 0) {
    filteredPriceTierItems.push({
      ProductId,
      basePrice: null,
      price,
      PriceTierId,
      active: true,
      discountable: true,
    });
  }

  return filteredPriceTierItems;
};

export default function ItemPricingTableRow({
  priceTier,
  productId,
  updatedPriceTierItems,
  setUpdatedPriceTierItems,
  warning,
}: {
  productId: number;
  priceTier: PriceTierListResponseType[number];
  setUpdatedPriceTierItems: (
    item: ProductPriceTierBatchCreateRequestType | undefined,
  ) => void;
  updatedPriceTierItems: ProductPriceTierBatchCreateRequestType | undefined;
  warning: boolean;
}) {
  const price = updatedPriceTierItems?.find(
    (item) => item.PriceTierId === priceTier.id,
  )?.price;
  const priceFormat = usePriceFormat(price);

  return (
    <TableLegacyTR>
      <TableLegacyTD>{priceTier.name}</TableLegacyTD>
      <TableLegacyTD>
        <InputContainer
          className={twMerge(
            "w-[16ch]",
            warning &&
              !updatedPriceTierItems?.length &&
              "shadow-[0_0px_8px_0_rgba(249,115,22,0.75)]",
          )}
        >
          <InputCurrency
            showPrefix
            allowNegative
            placeholder="No price"
            value={priceFormat.inputFormat}
            onChange={(e) => {
              priceFormat.setInputFormat(e.target.value);
              const price = formatPriceInputToApi(e.target.value);
              setUpdatedPriceTierItems(
                handleUpdateItems(
                  updatedPriceTierItems,
                  productId,
                  priceTier.id,
                  price,
                ),
              );
            }}
          />
        </InputContainer>
      </TableLegacyTD>
    </TableLegacyTR>
  );
}
